import { render, staticRenderFns } from "./ConfirmPopup.vue?vue&type=template&id=fd38965e&"
import script from "./ConfirmPopup.vue?vue&type=script&lang=js&"
export * from "./ConfirmPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports